import api from './api';

export const QuestionarioPublicoService = {
    buscarPoridQuestionarioPublico: (idQuestionarioPublico) => {
        const params = { incluirRespostas: true }

        return api.get(`questionario-publico/${idQuestionarioPublico}`, { params })
    }
}